export const WORKFLOW_STATE_STYLES = {
  Draft: "bg-slate-100 text-slate-700 border-slate-200",
  Open: "bg-blue-50 text-[#008080] border-blue-200",
  "In Review": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Awaiting Evidence": "bg-amber-50 text-amber-800 border-amber-200",
  "Awaiting Approval": "bg-purple-50 text-purple-700 border-purple-200",
  "Remediation Required": "bg-red-50 text-red-700 border-red-200",
  Completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Closed: "bg-slate-200 text-slate-700 border-slate-300",
  Cancelled: "bg-slate-50 text-slate-400 border-slate-200 line-through",
};

export const PRIORITY_STYLES = {
  Low: "bg-slate-100 text-slate-600",
  Medium: "bg-blue-50 text-[#008080]",
  High: "bg-amber-100 text-amber-800",
  Critical: "bg-red-100 text-red-700",
};

export const APPROVAL_STYLES = {
  Pending: "bg-purple-50 text-purple-700 border-purple-200",
  Approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Rejected: "bg-red-50 text-red-700 border-red-200",
  Cancelled: "bg-slate-100 text-slate-500 border-slate-200",
};

export const EVENT_STYLES = {
  record_created: { dot: "bg-emerald-500", text: "text-emerald-700" },
  record_updated: { dot: "bg-slate-400", text: "text-slate-700" },
  status_changed: { dot: "bg-indigo-500", text: "text-indigo-700" },
  owner_changed: { dot: "bg-sky-500", text: "text-sky-700" },
  attachment_added: { dot: "bg-teal-500", text: "text-teal-700" },
  evidence_uploaded: { dot: "bg-teal-600", text: "text-teal-700" },
  approval_requested: { dot: "bg-purple-400", text: "text-purple-700" },
  approval_given: { dot: "bg-emerald-600", text: "text-emerald-700" },
  approval_rejected: { dot: "bg-red-500", text: "text-red-700" },
  comment_added: { dot: "bg-amber-400", text: "text-amber-700" },
  record_deleted: { dot: "bg-red-400", text: "text-red-700" },
  integrity_verified: { dot: "bg-cyan-500", text: "text-cyan-700" },
};

export const fmtDT = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString("en-IN", {
    day: "2-digit", month: "short", year: "numeric", hour: "numeric", minute: "2-digit",
  });
};

export const fmtD = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
  return Number.isNaN(d.getTime())
    ? iso
    : d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

export const fmtBytes = (n) => {
  if (n == null) return "—";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
};

export const apiError = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || fallback;
};

export const shortVal = (v) => {
  if (v == null) return "—";
  if (typeof v === "object") {
    return Object.entries(v)
      .map(([k, val]) => `${k}: ${typeof val === "object" && val !== null ? JSON.stringify(val) : val ?? "—"}`)
      .join(" · ");
  }
  return String(v);
};
